import { InjectionToken } from '@angular/core';
import { environment } from 'src/environments/environment';
import { getEnvironmentName } from './utils/env-utils';

export enum EnvironmentName {
  EPIC = 'Epic',
  STANDALONE = 'Standalone',
}

export const ENV_CONFIG_TOKEN = new InjectionToken<EnvConfig>('config');
export interface EnvConfig {
  envName: string;
  apiBaseUrl: string;
  isStandalone: boolean;
}
export const getConfigValue = () => {
  const { urls } = environment;
  const envName = getEnvironmentName();

  return {
    envName,
    apiBaseUrl: envName === EnvironmentName.STANDALONE ? urls.standaloneApi : urls.api,
    isStandalone: envName === EnvironmentName.STANDALONE,
  };
};
